import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card p-6 pb-0 sm:p-8 mb-4"
}
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title-main" }, "สถานะการสั่งซื้อ", -1)
const _hoisted_5 = { class: "flex flex-col p-6 hidden xl:block" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-row bg-teal-200"
}
const _hoisted_7 = { class: "flex flex-col relative items-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "w-6 h-10 flex justify-center" }
const _hoisted_10 = { class: "ml-5 flex flex-col justify-start rounded bg-teal-200" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-teal-800" }, "แจ้งชำระเงิน", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("small", { class: "text-red-500" }, "คำสั่งซื้อถูกยกเลิก", -1)
const _hoisted_13 = { class: "text-gray-400" }
const _hoisted_14 = {
  key: 1,
  class: "flex flex-row bg-orange-200"
}
const _hoisted_15 = { class: "flex flex-col relative items-center" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "w-6 h-10 flex justify-center" }
const _hoisted_18 = { class: "ml-5 flex flex-col justify-start rounded bg-orange-200" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-orange-800" }, "ตรวจสอบการชำระเงิน", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("small", { class: "text-red-500" }, "คำสั่งซื้อถูกยกเลิก", -1)
const _hoisted_21 = { class: "text-gray-400" }
const _hoisted_22 = { class: "flex flex-row" }
const _hoisted_23 = { class: "flex flex-col relative items-center" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "w-6 h-10 flex justify-center" }
const _hoisted_26 = { class: "ml-5 flex flex-col justify-start rounded" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text-orange-800" }, "เตรียมการจัดส่ง", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("small", { class: "text-red-500" }, "คำสั่งซื้อถูกยกเลิก", -1)
const _hoisted_29 = { class: "text-gray-400" }
const _hoisted_30 = {
  key: 2,
  class: "flex flex-row"
}
const _hoisted_31 = { class: "flex flex-col relative items-center" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "w-6 h-10 flex justify-center" }
const _hoisted_34 = { class: "ml-5 flex flex-col justify-start rounded" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "text-orange-800" }, "อยู่ระหว่างการจัดส่ง", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("small", { class: "text-red-500" }, "คำสั่งซื้อถูกยกเลิก", -1)
const _hoisted_37 = { class: "text-gray-400" }
const _hoisted_38 = { class: "flex flex-row" }
const _hoisted_39 = { class: "flex flex-col relative items-center" }
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "ml-5 flex flex-col justify-start rounded" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "text-orange-800" }, "จัดส่งเรียบร้อย", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("small", { class: "text-red-500" }, "คำสั่งซื้อถูกยกเลิก", -1)
const _hoisted_44 = { class: "text-gray-400" }
const _hoisted_45 = { class: "flex flex-col px-10 pt-10 pb-0 block xl:hidden" }
const _hoisted_46 = { class: "bg-gray-200 rounded-full h-1 flex items-center justify-between mb-20 md:mx-10 relative" }
const _hoisted_47 = { class: "inline z-20 relative flex justify-center" }
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "flex flex-col items-center text-teal-800 text-sm xl:text-base absolute w-max mt-10" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("small", { class: "text-red-500" }, "คำสั่งซื้อถูกยกเลิก", -1)
const _hoisted_51 = { class: "text-gray-400" }
const _hoisted_52 = { class: "inline z-20 relative flex justify-center" }
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "flex flex-col items-center text-teal-800 text-sm xl:text-base absolute w-max mt-10" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("small", { class: "text-red-500" }, "คำสั่งซื้อถูกยกเลิก", -1)
const _hoisted_56 = { class: "text-gray-400" }
const _hoisted_57 = { class: "inline z-20 relative flex justify-center" }
const _hoisted_58 = ["src"]
const _hoisted_59 = { class: "flex flex-col items-center text-teal-800 text-sm xl:text-base absolute w-max mt-10" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("small", { class: "text-red-500" }, "คำสั่งซื้อถูกยกเลิก", -1)
const _hoisted_61 = { class: "text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "bullet_main",
            src: require('@/assets/icon_bullet/status.svg'),
            alt: ""
          }, null, 8, _hoisted_3),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          (
          !_ctx.data.shippingConfirmedData ||
          (_ctx.data.shippingConfirmedData && !_ctx.data.shippingConfirmedData.isCOD)
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.func_service.chkWaitPayment(_ctx.data).class, "w-8 h-8 rounded-full border border-gray-300 object-scale-down bg-white flex justify-center items-center"])
                  }, [
                    _createElementVNode("img", {
                      src: require('@/' + _ctx.func_service.chkWaitPayment(_ctx.data).image)
                    }, null, 8, _hoisted_8)
                  ], 2),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass([_ctx.func_service.chkWaitPayment(_ctx.data).classLine, "h-full border-r-2 border-teal-300 border"])
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  (_ctx.func_service.chkWaitPayment(_ctx.data).cancel.status)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_12,
                        _createElementVNode("small", _hoisted_13, _toDisplayString(_ctx.formatDate(_ctx.func_service.chkPayment(_ctx.data).cancel.date)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (
          !_ctx.data.shippingConfirmedData ||
          (_ctx.data.shippingConfirmedData && !_ctx.data.shippingConfirmedData.isCOD)
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.func_service.chkPayment(_ctx.data).class, "w-8 h-8 rounded-full border border-gray-300 object-scale-down flex justify-center items-center"])
                  }, [
                    _createElementVNode("img", {
                      src: require('@/' + _ctx.func_service.chkPayment(_ctx.data).image)
                    }, null, 8, _hoisted_16)
                  ], 2),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", {
                      class: _normalizeClass([_ctx.func_service.chkPayment(_ctx.data).classLine, "h-full border-r-2 border-orange-300 border"])
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  (_ctx.func_service.chkPayment(_ctx.data).cancel.status)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_20,
                        _createElementVNode("small", _hoisted_21, _toDisplayString(_ctx.formatDate(_ctx.func_service.chkPayment(_ctx.data).cancel.date)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.func_service.chkWaitShipping(_ctx.data).class, "w-8 h-8 rounded-full border border-gray-300 object-scale-down flex items-center justify-center"])
              }, [
                _createElementVNode("img", {
                  src: require('@/' + _ctx.func_service.chkWaitShipping(_ctx.data).image)
                }, null, 8, _hoisted_24)
              ], 2),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", {
                  class: _normalizeClass([_ctx.func_service.chkWaitShipping(_ctx.data).classLine, "h-full border-r-2 border-orange-300 border"])
                }, null, 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              (_ctx.func_service.chkWaitShipping(_ctx.data).cancel.status)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_28,
                    _createElementVNode("small", _hoisted_29, _toDisplayString(_ctx.formatDate(_ctx.func_service.chkPayment(_ctx.data).cancel.date)), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          (
          _ctx.data.statusOrderOnBuyer === _ctx.StatusOrderCustomer.B1_AwaitingConfirm ||
          _ctx.func_service.validatePickup(_ctx.data?.shippingConfirmedData, _ctx.data)
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.func_service.chkShipping(_ctx.data).class, "w-8 h-8 rounded-full border border-gray-300 object-scale-down flex items-center justify-center"])
                  }, [
                    _createElementVNode("img", {
                      src: require('@/' + _ctx.func_service.chkShipping(_ctx.data).image)
                    }, null, 8, _hoisted_32)
                  ], 2),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", {
                      class: _normalizeClass([_ctx.func_service.chkShipping(_ctx.data).classLine, "h-full border-r-2 border-orange-300 border"])
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  (_ctx.func_service.chkShipping(_ctx.data).cancel.status)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_36,
                        _createElementVNode("small", _hoisted_37, _toDisplayString(_ctx.formatDate(_ctx.func_service.chkPayment(_ctx.data).cancel.date)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.func_service.chkSuccess(_ctx.data).class, "w-8 h-8 rounded-full border border-gray-300 object-scale-down flex items-center justify-center"])
              }, [
                _createElementVNode("img", {
                  src: require('@/' + _ctx.func_service.chkSuccess(_ctx.data).image)
                }, null, 8, _hoisted_40)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              (_ctx.func_service.chkSuccess(_ctx.data).cancel.status)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_43,
                    _createElementVNode("small", _hoisted_44, _toDisplayString(_ctx.formatDate(_ctx.func_service.chkPayment(_ctx.data).cancel.date)), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", {
              class: _normalizeClass(["line absolute h-1 bg-blue-ocean-600", 
            _ctx.data.statusOrderOnBuyer ===
              _ctx.StatusOrderCustomer.B1_AwaitingConfirm ||
            (_ctx.data.statusOrderOnBuyer ===
              _ctx.StatusOrderCustomer.B2_AwaitingPayment &&
              _ctx.data.statusOrderOnSeller !== _ctx.StatusOrderSeller.S3_ToConfirm)
              ? ''
              : _ctx.data.statusOrderOnSeller == _ctx.StatusOrderSeller.S8_Completed
              ? 'w-full'
              : 'w-6/12'
          ])
            }, null, 2),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.func_service.chkStep1(_ctx.data).class, "w-8 h-8 rounded-full border border-gray-300 object-scale-down bg-white flex justify-center items-center"])
              }, [
                _createElementVNode("img", {
                  src: require('@/' + _ctx.func_service.chkStep1(_ctx.data).image)
                }, null, 8, _hoisted_48)
              ], 2),
              _createElementVNode("div", _hoisted_49, [
                _createTextVNode(_toDisplayString(_ctx.func_service.chkStep1(_ctx.data).status) + " ", 1),
                (_ctx.func_service.chkStep1(_ctx.data).cancel.status)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_50,
                      _createElementVNode("small", _hoisted_51, _toDisplayString(_ctx.formatDate(_ctx.func_service.chkPayment(_ctx.data).cancel.date)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.func_service.chkStep2(_ctx.data).class, "w-8 h-8 rounded-full border border-gray-300 object-scale-down bg-white flex justify-center items-center"])
              }, [
                _createElementVNode("img", {
                  src: require('@/' + _ctx.func_service.chkStep2(_ctx.data).image)
                }, null, 8, _hoisted_53)
              ], 2),
              _createElementVNode("div", _hoisted_54, [
                _createTextVNode(_toDisplayString(_ctx.func_service.chkStep2(_ctx.data).status) + " ", 1),
                (_ctx.func_service.chkStep2(_ctx.data).cancel.status)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_55,
                      _createElementVNode("small", _hoisted_56, _toDisplayString(_ctx.formatDate(_ctx.func_service.chkPayment(_ctx.data).cancel.date)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.func_service.chkStep3(_ctx.data).class, "w-8 h-8 rounded-full border border-gray-300 object-scale-down bg-white flex justify-center items-center"])
              }, [
                _createElementVNode("img", {
                  src: require('@/' + _ctx.func_service.chkStep3(_ctx.data).image)
                }, null, 8, _hoisted_58)
              ], 2),
              _createElementVNode("div", _hoisted_59, [
                _createTextVNode(_toDisplayString(_ctx.func_service.chkStep3(_ctx.data).status) + " ", 1),
                (_ctx.func_service.chkStep3(_ctx.data).cancel.status)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_60,
                      _createElementVNode("small", _hoisted_61, _toDisplayString(_ctx.formatDate(_ctx.func_service.chkPayment(_ctx.data).cancel.date)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}